import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { LandingPageComponentType } from "@type/models/cms-landing";
import BrowseCarsBy from "@/pages/landingPages/components/sections__BrowseCarsBy/BrowseCarsBy";
import { carPrices__translateText, cars_prices__urlHelper, CARS_PRICES_BASE_PATH, xxxx_getMakesModels } from "@/pages/car-prices/helpers/carsPricesHelpers";
import CarPriceSearchSection from "@/pages/car-prices/ui/carPriceSearchSection/CarPriceSearchSection";
import CarPriceTableSection from "@/pages/car-prices/ui/CarPriceTableSection/CarPriceTableSection";
import CarMakeContainer from "@/pages/landingPages/components/CarMakeContainer/CarMakeContainer";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./CarsPrices.module.css";
import useIsMobile from "@hooks/useIsMobile";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import yearList from "@data/cars-prices-data/year.json";
var BrowseCarsPrices = function BrowseCarsPrices(_ref) {
  var selectedMake = _ref.selectedMake,
    selectedModel = _ref.selectedModel,
    headingType = _ref.headingType,
    year = _ref.year,
    title = _ref.title,
    scenario = _ref.scenario,
    cta = _ref.cta;
  var lang = useLang();
  var _xxxx_getMakesModels = xxxx_getMakesModels(lang, selectedMake, selectedModel),
    makes = _xxxx_getMakesModels.makes,
    models = _xxxx_getMakesModels.models,
    years = _xxxx_getMakesModels.years;
  var items = [];
  var createLinkPropFunc;
  switch (scenario) {
    case "makes":
      items = makes;
      createLinkPropFunc = function createLinkPropFunc(make) {
        return cars_prices__urlHelper(CARS_PRICES_BASE_PATH, lang) + "/".concat(make.seo_url);
      };
      break;
    case "models":
      items = models;
      createLinkPropFunc = function createLinkPropFunc(model) {
        return cars_prices__urlHelper("".concat(CARS_PRICES_BASE_PATH, "{make}"), lang, selectedMake) + "/".concat(model.seo_name);
      };
      break;
    case "years":
      createLinkPropFunc = function createLinkPropFunc(yearNum) {
        return cars_prices__urlHelper("".concat(CARS_PRICES_BASE_PATH, "{make}{model}"), lang, selectedMake, selectedModel) + "/".concat(yearNum);
      };
      items = years.filter(function (year) {
        return yearList[selectedMake.seo_url + '/' + selectedModel.seo_name + '/' + year];
      });
      break;
  }
  return /*#__PURE__*/React.createElement(CarMakeContainer, {
    showAsListOnMobile: true,
    headingType: headingType,
    title: carPrices__translateText(title, selectedMake, selectedModel, year, lang),
    cta: cta,
    carMakesOrModelOrYears: items,
    createLinkProp: createLinkPropFunc,
    printLabel: function printLabel(item) {
      return item.name || item;
    }
  });
};
var BrowseCarsByPriceRange = function BrowseCarsByPriceRange(_ref2) {
  var selectedMake = _ref2.selectedMake,
    selectedModel = _ref2.selectedModel,
    year = _ref2.year,
    title = _ref2.title,
    headingType = _ref2.headingType,
    link_base_path = _ref2.link_base_path;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var lang = useLang();
  var _useFullPageData = useFullPageData(),
    prices_ranges = _useFullPageData.prices_ranges;
  var sellingPriceRange = prices_ranges.map(function (price_range) {
    return {
      id: price_range.price,
      text: "".concat(price_range.text || "", " ").concat(price_range.price, " ").concat(price_range.unit),
      range: price_range.price,
      filters: {
        sellingprice_to: price_range.to,
        sellingprice_from: price_range.from
      }
    };
  });
  return /*#__PURE__*/React.createElement(CarMakeContainer, {
    showAsListOnMobile: true,
    title: carPrices__translateText(title, selectedMake, selectedModel, year, lang),
    headingType: headingType,
    carMakesOrModelOrYears: sellingPriceRange,
    link_base_path: link_base_path,
    printLabel: function printLabel(item) {
      return item.text;
    },
    createLinkProp: function createLinkProp(item) {
      return createUrl("/filters", _objectSpread(_objectSpread({}, item.filters), {}, {
        make_id: selectedMake === null || selectedMake === void 0 ? void 0 : selectedMake.id,
        model_id: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.id
      }));
    }
  });
};
var BreadcrumbGeneric = function BreadcrumbGeneric(_ref3) {
  var breadcrumb = _ref3.breadcrumb,
    selectedMake = _ref3.selectedMake,
    selectedModel = _ref3.selectedModel,
    year = _ref3.year;
  var lang = useLang();
  var extraLinks = [];
  if (breadcrumb.label1) {
    extraLinks.push({
      link: cars_prices__urlHelper(breadcrumb.link1, lang, selectedMake, selectedModel, year),
      title: carPrices__translateText(breadcrumb.label1, selectedMake, selectedModel, year, lang)
    });
  }
  if (breadcrumb.label2) {
    extraLinks.push({
      link: cars_prices__urlHelper(breadcrumb.link2, lang, selectedMake, selectedModel, year),
      title: carPrices__translateText(breadcrumb.label2, selectedMake, selectedModel, year, lang)
    });
  }
  if (breadcrumb.label3) {
    extraLinks.push({
      link: cars_prices__urlHelper(breadcrumb.link3, lang, selectedMake, selectedModel, year),
      title: carPrices__translateText(breadcrumb.label3, selectedMake, selectedModel, year, lang)
    });
  }
  if (breadcrumb.label4) {
    extraLinks.push({
      link: cars_prices__urlHelper(breadcrumb.link4, lang, selectedMake, selectedModel, year),
      title: carPrices__translateText(breadcrumb.label4, selectedMake, selectedModel, year, lang)
    });
  }
  return /*#__PURE__*/React.createElement(BreadCrumb, {
    hasSchemaOrg: true,
    links: [].concat(extraLinks)
  });
};
export default function carsPrices__renderHeadlessComponent(carsPageResponse, landingSectionProps) {
  var selectedMake = carsPageResponse.selectedMake,
    selectedModel = carsPageResponse.selectedModel,
    year = carsPageResponse.year;
  var lang = useLang();
  var isMobile = useIsMobile();
  switch (landingSectionProps.__component) {
    case LandingPageComponentType.LP_CAR_PRICES_HERO:
      var carPriceSearchSection = landingSectionProps;
      return /*#__PURE__*/React.createElement(CarPriceSearchSection, {
        selectedMake: selectedMake,
        selectedModel: selectedModel,
        year: year,
        heading: carPriceSearchSection.heading,
        title: carPrices__translateText(carPriceSearchSection.title, selectedMake, selectedModel, year, lang),
        subtitle: carPrices__translateText(carPriceSearchSection.subtitle, selectedMake, selectedModel, year, lang)
      });
    case LandingPageComponentType.LAYOUT_BREADCRUMB:
      return /*#__PURE__*/React.createElement("div", {
        className: "max-width mx-auto mt-8 md:mt-10"
      }, /*#__PURE__*/React.createElement(BreadcrumbGeneric, {
        breadcrumb: landingSectionProps,
        selectedMake: selectedMake,
        selectedModel: selectedModel,
        year: year
      }));
    case LandingPageComponentType.LP_CAR_PRICES_CAR_PRICES_DETAILS_TABLE:
      var carPriceTableSectionProps = landingSectionProps;
      return /*#__PURE__*/React.createElement("div", {
        className: "max-width mx-auto mt-10 md:mt-8"
      }, /*#__PURE__*/React.createElement(CarPriceTableSection, {
        carPricesDataStructure: carsPageResponse.carPricesDataStructure,
        splitPoint: isMobile ? carPriceTableSectionProps.number_of_items_mobile : carPriceTableSectionProps.number_of_items_desktop,
        headingType: carPriceTableSectionProps.heading,
        cta: carPriceTableSectionProps.cta,
        title: carPrices__translateText(carPriceTableSectionProps.title, selectedMake, selectedModel, year, lang),
        disclaimer: carPriceTableSectionProps.disclaimer,
        subtitle: carPrices__translateText(carPriceTableSectionProps.subtitle, selectedMake, selectedModel, year, lang),
        selectedMake: selectedMake,
        selectedModel: selectedModel
      }));
    case LandingPageComponentType.BROWSE_CARS_BY:
      var browseCarsByProps = landingSectionProps;
      return /*#__PURE__*/React.createElement("div", {
        className: "margin-auto"
      }, /*#__PURE__*/React.createElement(BrowseCarsBy, {
        headingType: browseCarsByProps.heading,
        number_of_cars: browseCarsByProps.number_of_cars,
        products: carsPageResponse.products,
        cta: browseCarsByProps.cta,
        url: cars_prices__urlHelper(browseCarsByProps.cta.url, lang, selectedMake, selectedModel, year),
        title: carPrices__translateText(browseCarsByProps.title, selectedMake, selectedModel, year, lang)
      }));
    case LandingPageComponentType.LP_COMPONENTS_BROWSER_CARS_BY_PRICE_RANGE:
      var browseCarsByPriceRangeProps = landingSectionProps;
      return /*#__PURE__*/React.createElement("div", {
        className: ["max-width margin-auto mt-1", stl.BrowseCarsByPriceRangeCustomWidth].join(" ")
      }, /*#__PURE__*/React.createElement(BrowseCarsByPriceRange, _extends({}, landingSectionProps, {
        headingType: browseCarsByPriceRangeProps.heading,
        year: year,
        selectedMake: selectedMake,
        selectedModel: selectedModel
      })));
    case LandingPageComponentType.LP_CAR_PRICES_BROWSER_PRICES_MK_MDL_YR:
      var browseCarsByPricesProps = landingSectionProps;
      return /*#__PURE__*/React.createElement("div", {
        className: ["max-width margin-auto mt-1", stl.BrowseCarsByPriceRangeCustomWidth].join(" ")
      }, /*#__PURE__*/React.createElement(BrowseCarsPrices, _extends({}, landingSectionProps, {
        headingType: browseCarsByPricesProps.heading,
        year: year,
        selectedMake: selectedMake,
        selectedModel: selectedModel
      })));
    default:
      return /*#__PURE__*/React.createElement("div", null, landingSectionProps.__component);
  }
}